import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import { displayMobileNumber, validateMobileNumber } from '../../utils/formatDate';

const InvoiceTable = ({ rows, shops = [], minimal, businessView }) => {
  const isMinimal = minimal || businessView;
  
  const renderCustomerNumber = (customerNumber) => {
    const formattedNumber = displayMobileNumber(customerNumber);
    const isValid = validateMobileNumber(customerNumber);
    
    return (
      <Tooltip 
        title={!isValid ? "Invalid mobile number format" : ""}
        placement="top"
      >
        <Link 
          to={`/customers/${customerNumber}`} 
          style={{ 
            color: isValid ? '#111827' : '#dc2626', 
            textDecoration: 'underline', 
            fontWeight: 500 
          }}
        >
          {formattedNumber}
        </Link>
      </Tooltip>
    );
  };

  return (
     <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 'none', overflow: 'hidden', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', minHeight: 320 }}>
        <Table size="small" sx={{ minWidth: { xs: 360, sm: 700 } }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: 'text.primary', fontWeight: 700, pl: 2, minWidth: 140, borderBottom: '1px solid', borderColor: 'divider' }}>Invoice</TableCell>
              <TableCell sx={{ color: 'text.primary', fontWeight: 700, borderBottom: '1px solid', borderColor: 'divider' }}>Customer</TableCell>
              <TableCell sx={{ color: 'text.primary', fontWeight: 700, borderBottom: '1px solid', borderColor: 'divider', display: { xs: 'none', sm: 'table-cell' } }}>Amount</TableCell>
              <TableCell sx={{ color: 'text.primary', fontWeight: 700, minWidth: 120, borderBottom: '1px solid', borderColor: 'divider' }}>Date</TableCell>
              {!minimal && <TableCell sx={{ color: 'text.primary', fontWeight: 700, borderBottom: '1px solid', borderColor: 'divider', display: { xs: 'none', md: 'table-cell' } }}>Shop</TableCell>}
              {!minimal && <TableCell sx={{ color: 'text.primary', fontWeight: 700, borderBottom: '1px solid', borderColor: 'divider', display: { xs: 'none', md: 'table-cell' } }}>Category</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={row.invoiceId} hover>
                <TableCell sx={{ pl: 2 }}>{row.invoiceId}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {row.customerNumber}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.amount}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.date}</TableCell>
                {!minimal && (
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                    <Link to={`/shops/${row.shopId}`} style={{ color: '#111827', textDecoration: 'underline', fontWeight: 500 }}>
                      {shops.find(s => s.id === row.shopId)?.name || row.shopId}
                    </Link>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InvoiceTable; 
